import type { BoxesTitleContent } from "../../pages/boxes/content/heading.js";

/** The page's heading. */
export function ClassicBoxesTitle({ text }: BoxesTitleContent) {
  return <h1 className="text-2xl font-semibold tracking-tight text-foreground">{text}</h1>;
}
